/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #eee;
  }
  .none {
    fill: none;
  }
`

export default function HomeIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <g id="그룹_6956" data-name="그룹 6956" transform="translate(15828.999 12303)">
        <rect id="사각형_6570" data-name="사각형 6570" width="22" height="22" transform="translate(-15828.999 -12303)" fill="#1993ff" opacity="0"/>
        <path id="패스_6338" className="fill" data-name="패스 6338" d="M578.846,632.292h-2.965a.6.6,0,0,1-.6-.6v-4.829a.4.4,0,0,0-.4-.4H571.76a.4.4,0,0,0-.4.4v4.831a.6.6,0,0,1-.6.6h-2.967a2.1,2.1,0,0,1-2.1-2.1v-7.147h-1.064a1.4,1.4,0,0,1-.923-2.449l8.682-7.741a1.4,1.4,0,0,1,1.863,0l8.685,7.742a1.4,1.4,0,0,1-.929,2.448h-1.061v7.147A2.1,2.1,0,0,1,578.846,632.292Zm-2.365-1.2h2.365a.9.9,0,0,0,.9-.9v-7.747a.6.6,0,0,1,.6-.6H582a.237.237,0,0,0,.155-.069.2.2,0,0,0-.019-.283l-8.686-7.742a.2.2,0,0,0-.267,0l-8.683,7.741a.2.2,0,0,0-.07.153.2.2,0,0,0,.2.2h1.661a.6.6,0,0,1,.6.6v7.747a.9.9,0,0,0,.9.9h2.367v-4.23a1.6,1.6,0,0,1,1.6-1.6h3.121a1.6,1.6,0,0,1,1.6,1.6Z" transform="translate(-16391.332 -12914.501)"/>
      </g>
    </svg>
  )
}
